import * as React from 'react';
import {useEffect} from 'react';
import {withNavigation} from '../navigation/navigation';
import DataTable from 'react-data-table-component';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {Box, Button, Stack, Typography, Breadcrumbs} from '@mui/material';
import {usePoliceMode} from '../policeMode/hook/usePoliceMode';
import StarIcon from '@mui/icons-material/StarBorder';
import SwapVertIcon from '@mui/icons-material/FilterList';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {useOrderHistory} from './hooks/useOrderHistory';
import {withOrderHistoryContext} from './state/orderHistoryContext';
import {useNavigate} from 'react-router-dom';
import {useSubmit} from './hooks/useSubmit';
import ExpandlessPlaceholder from '../placeholder/ExpandlessPlacehoder';
import Container from '@mui/material/Container';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const QuoteHistory = ({history}) => {
  const {mode} = useDarkMode();
  const {police} = usePoliceMode();
  console.log('History:', history);
  const {createOrderFromOld} = useSubmit();
  const navigate = useNavigate();

  const breadcrumbs = [
    <Typography
      className={'breadcrumbs'}
      variant={'body2'}
      onClick={() => navigate('/')}
      style={{color: mode.settings.breadcrumbColor1}}>
      Accueil
    </Typography>,
    <Typography variant={'body2'} style={{color: mode.settings.textColor3}}>
      Mes commandes
    </Typography>,
  ];

  const columns = [
    {
      name: 'Mes devis',
      selector: row => row.order,
      cell: row => {
        return (
          <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            width={'100%'}
            flexWrap={'wrap'}
            gap={'5px'}>
            <Stack direction={'row'} alignItems={'center'} gap={1}>
              <Box
                sx={{
                  backgroundColor: '#F2F4F8',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '40px', // Adjust the size as needed
                  height: '40px', // Adjust the size as needed
                }}>
                <img
                  src={`/assets/icon/${row.productCategory}.png`}
                  alt="service"
                  style={{width: '27px'}}
                />
              </Box>
              <Typography
                variant={'subtitle6'}
                color={mode.settings.textColor3}>
                {row.product.name}
              </Typography>
            </Stack>
          </Stack>
        );
      },
      maxWidth: '300px',
    },
    {
      name: 'Status',
      selector: row => row.status,
      cell: row => {
        return (
          <Typography variant={'subtitle6'} color={mode.settings.textColor3}>
            {row.status}
          </Typography>
        );
      },
      maxWidth: '200px',
    },
    {
      name: 'Prix (HT)',
      selector: row => row.status,
      cell: row => {
        return (
          <Typography variant={'subtitle6'} color={mode.settings.textColor3}>
            {row.price ? row.price + ' €' : 'En cours'}
          </Typography>
        );
      },
      maxWidth: '120px',
    },
    {
      name: 'Détails',
      selector: row => row.content,
      sortable: true,
      cell: row => {
        return (
          <Stack
            direction={'column'}
            alignItems={'flex-start'}
            justifyContental={'space-between'}
            width={'100%'}>
            {JSON.parse(row.content).map((item, index) => {
              let value = item.value;
              if (item.type === 'dateTime' || item.type === 'rdv')
                value = new Date(item.value).toLocaleString();

              return (
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  gap={1}
                  key={index}>
                  <Typography
                    variant={'subtitle8'}
                    color={mode.settings.textColor3}>
                    {item.label} :
                  </Typography>
                  <Typography
                    variant={'subtitle6'}
                    color={mode.settings.textColor3}>
                    {value}
                  </Typography>
                </Stack>
              );
            })}
          </Stack>
        );
      },
    },
    {
      name: 'Actions',
      selector: row => row.accept_url,
      sortable: true,
      cell: row => {
        return (
          <div style={{width: '100%'}}>
            {row.acceptUrl && row.cancelUrl ? (
              <Stack
                direction={'column'}
                alignItems={'center'}
                justifyContental={'space-between'}
                width={'100%'}
                gap={2}>
                <Button
                  className="btn-gradient"
                  variant="contained"
                  size="large"
                  startIcon={
                    <CheckIcon role="img" aria-label={'Accepter le devis'} />
                  }
                  sx={{minWidth: '255px'}}
                  onClick={() => {
                    window.location.href = row.acceptUrl;
                  }}
                  aria-label={"Voir le détail de l'évenement"}>
                  <Typography variant={'subtitle3'}>
                    Accepter le devis
                  </Typography>
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  startIcon={
                    <CloseIcon role="img" aria-label={'Refuser le devis'} />
                  }
                  sx={{
                    minWidth: '255px',
                    backgroundColor: '#DD809D',
                  }}
                  onClick={() => {
                    window.location.href = row.cancelUrl;
                  }}
                  aria-label={"Voir le détail de l'évenement"}>
                  <Typography variant={'subtitle3'}>
                    Refuser le devis
                  </Typography>
                </Button>
              </Stack>
            ) : (
              <div></div>
            )}
          </div>
        );
      },
    },
  ];

  const customStyles = {
    // rows: {
    //     style: {
    //         fontFamily: police.normalMode ? 'Roboto' : 'Comic Sans MS'
    //     },
    // },
    headCells: {
      style: {
        color: mode.settings.textColor9,
        fontFamily: police.normalMode ? 'Roboto' : 'Dyslexic',
        fontSize: '18px',
        backgroundColor: mode.settings.cardBackgroundColor,
      },
    },
    cells: {
      style: {
        color: mode.settings.textColor9,
        fontFamily: police.normalMode ? 'Roboto' : 'Dyslexic',
        backgroundColor: mode.settings.cardBackgroundColor,
      },
    },
    pagination: {
      style: {
        color: mode.settings.textColor9,
        fontFamily: police.normalMode ? 'Roboto' : 'Dyslexic',
        backgroundColor: mode.settings.cardBackgroundColor,
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: 'Résultat par page',
    rangeSeparatorText: 'sur',
    selectAllRowsItem: false,
    selectAllRowsItemText: 'Todos',
  };

  return (
    <Box sx={{width: '100%', marginTop: '30px'}}>
      <Typography
        variant="h5"
        sx={{
          mt: {xs: 2, md: 2, lg: 2},
          mb: {xs: 4, md: 4, lg: 2},
          textAlign: {xs: 'center', md: 'center', lg: 'left'},
        }}
        style={{color: mode.settings.textColor3}}
        id={'anchor0'}>
        {' '}
        Suivi de mes devis{' '}
      </Typography>
      <DataTable
        columns={columns}
        data={history}
        customStyles={customStyles}
        sortIcon={
          <SwapVertIcon
            style={{
              fontSize: '50px',
              marginTop: '5px',
              marginLeft: '20px',
              width: '35px',
              height: 'auto',
            }}
          />
        }
        pagination
        paginationComponentOptions={paginationComponentOptions}
        noDataComponent={<div>Vous n'avez pas encore de devis</div>}
      />
    </Box>
  );
};

export default withOrderHistoryContext(QuoteHistory);
